import { ChangeDetectionStrategy, Component, signal } from '@angular/core';

@Component({
    selector: 'qpx-cmdk-separator',
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'qpx-cmdk-separator',
        role: 'separator',
        '[class.hidden]': '!showSeparator()',
    },
})
export class QpxCmdkSeparator {
    //#region State
    protected readonly showSeparator = signal(true);
    //#endregion

    //#region Public methods
    public setShowSeparator(value: boolean): void {
        this.showSeparator.set(value);
    }
    //#endregion
}
